import { WebStorageStateStore } from 'oidc-client';
import { createUserManager } from 'redux-oidc'
const config = {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    logout_uri:process.env.REACT_LOGOUT_URL,
    response_type: "code",
    scope: "openid profile CardsManageService CardsService IdentityService AdministrationService SaasService AccountService",
    silent_redirect_uri:process.env.REACT_APP_SILENT_REDIRECT_URI,
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    silentRequestTimeout :30000,
    post_logout_redirect_uri:window.location.origin
}
const userManager = createUserManager(config);
export { userManager }